import React, { FunctionComponent } from 'react';

import SimpleArtist from '@common/types/artist/simple-artist';

import styled from 'styled-components';

import LogoIcon from '@components/basics/logoIcon';
import Typography from '@components/basics/typography';

interface ArtistSelectorItemProps {
  className?: string;
  artist: SimpleArtist;
  onClick: (artist: SimpleArtist) => void;
}

const ArtistSelectorItem: FunctionComponent<ArtistSelectorItemProps> = ({
  className,
  artist,
  onClick,
}) => {
  return (
    <div className={className || ''} onClick={() => onClick(artist)}>
      {artist.avatar ? (
        <SquareAvatar src={artist.avatar} alt={artist.name} />
      ) : (
        <SquareLogo>
          <LogoIcon color="red" />
        </SquareLogo>
      )}
      <Typography align="center" weight="700">
        {artist.name.length > 20
          ? `${artist.name.slice(0, 20)}...`
          : artist.name}
      </Typography>
    </div>
  );
};

export default styled(ArtistSelectorItem)`
  max-width: 150px;
  cursor: pointer;
`;

const SquareAvatar = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: ${({ theme }) => theme.colors.differentBackground};
`;
const SquareLogo = styled.div`
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: ${({ theme }) => theme.colors.black};

  svg {
    width: 35%;
    height: 35%;
  }
`;
